<template>
  <NuxtLink
    v-bind="$attrs"
    :to="to || href"
    class="c-link"
    :class="{
      [`c-link--${variant}`]: variant,
      [`c-link--${size}`]: size,
      'c-link--no-underline': !underline,
      'c-link--no-bold': !bold,
      'c-link--disabled': isDisabled,
      'c-link--visited': useVisited,
    }"
    name="link"
    :tabindex="isDisabled ? -1 : ''"
  >
    <CIcon
      v-if="icon && iconPosition === 'left'"
      class="c-link__icon--left"
      :name="icon"
    />
    <span class="c-link--text">
      <slot />
    </span>
    <CIcon
      v-if="icon && iconPosition === 'right'"
      class="c-link__icon--right"
      :name="icon"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router'
import CIcon from '../../atoms/CIcon'

interface Props {
  variant?: 'primary' | 'dark' | 'light'
  size?: 'small' | 'medium'
  underline?: boolean
  bold?: boolean
  isDisabled?: boolean
  icon?: string
  to?: string | RouteLocationRaw
  href?: string
  iconPosition?: 'left' | 'right'
  useVisited?: boolean
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'medium',
  underline: true,
  bold: true,
  isDisabled: false,
  icon: '',
  href: undefined,
  to: undefined,
  iconPosition: undefined,
  useVisited: true,
})
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CLink',
})
</script>
